import React from "react";
import { useTranslation } from "react-i18next";
import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { useAppSelector } from "app/store";
import { i18nStrings, profileActions } from "./config";
import styles from "./style.module.scss";
import logo from "./logo.svg";
import { useDomain } from "../../utils/stage-utils";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { Badge } from "@amzn/awsui-components-react";
import { useTaxType } from "../../hooks/useTaxType";
import { TaxType } from "../../common/constants";

const Header: React.FC = () => {
  const { fullName, email, alias } = useAppSelector((state) => state.auth.user);
  const { t } = useTranslation();
  const domain = useDomain();
  const taxType = useTaxType();

  const appTitle = taxType === TaxType.PST ? t("app_name_pst") : t("app_name");

  const filteredProfileActions = profileActions.map((group) => ({
    ...group,
    items: group.items
      .filter((item) => item.taxTypes.includes(taxType as TaxType))
      .map(({ taxTypes, ...rest }) => rest),
  }));

  return (
    <TopNavigation
      id="header"
      className={styles.header}
      i18nStrings={i18nStrings}
      identity={{
        href: "#",
        title: (
          <SpaceBetween
            size={"s"}
            direction={"horizontal"}
            alignItems={"center"}
          >
            {appTitle}
            {<Badge color="blue">{domain.toString().toUpperCase()}</Badge>}
          </SpaceBetween>
        ) as unknown as string,
        logo: { src: logo, alt: appTitle },
      }}
      utilities={[
        {
          type: "menu-dropdown",
          text: fullName + " (" + alias + ")",
          description: email,
          iconName: "user-profile",
          items: filteredProfileActions,
        },
      ]}
    />
  );
};

export default Header;
